const getters = {
  sidebar: state => state.app.sidebar,
  size: state => state.app.size,
  device: state => state.app.device,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  introduction: state => state.user.introduction,
  roles: state => state.user.roles,
  permissions: state => state.user.permissions,
  permission_routes: state => state.permission.routes,
  userInfo: state => state.user.userInfo,
  annualInfo: state => state.permission.annualInfo,
  auditManager: state => state.user.auditManager,
  metaMaskObj: state => state.app.MetaMaskObj,
  auctionStatusMap: state => state.app.auctionStatusMap,
  voteStatusMap: state => state.app.voteStatusMap,
  proposalStatus:state => state.app.proposalStatus,
  proposalType:state => state.app.proposalType,
  proposalExecutedStatus: state => state.app.proposalExecutedStatus,
  gas:state => state.app.gas,
  contractMap:state => state.app.contractMap,
  bidStatusMap:state => state.app.bidStatusMap
}
export default getters
